module.exports = __webpack_public_path__ + "static/img/2-open-new.650cbbad.png";